<template>
  <div>
    <div class="mapdiv" v-if="tk&&mkList.length>0">
      <pl-lazy>
        <main-map
            ref="mainmap"
            :lyrdata="lyrdata"
            :mapCtrlTools="mapCtrlTools4Use"
            :mapParams="mapParams"
            :showSearchBar="false"
        >
        </main-map>
      </pl-lazy>
    </div>
    <div class="bak" v-if="showBak"></div>

    <!-- 其他DOM -->
    <div class="laboratoryLogo">
      <div class="mark"></div>
      <!--顶部导航栏-->
      <div :class="showMyLayersAndVectorPanel==true ? 'tabsNavi' : 'tabsNavi-s'">
        <SearchBar></SearchBar>
        <div class="tabsNaviClose" @click="$router.push('/rsManage')">关闭</div>
      </div>
      <!--左侧导航栏-->
      <div class="layersAndVectorsPanel">
        <myVector></myVector>
      </div>
      <div class="closePanelImg" @click="showMyLayersAndVectorPanel=true"></div>

    </div>

    <v-overlay :value="overlay">
      <span>正在处理，请稍后</span>
      <v-progress-circular indeterminate size="32"></v-progress-circular>
    </v-overlay>
    <v-snackbar v-model="snackbar" :color=snackbarColor :timeout="timeout" bottom>
      {{snackbarInfo}}
      <v-btn dark text @click="snackbar = false" class="text-capitalize">
        {{$vuetify.lang.t('$vuetify.demand.close')}}</v-btn>
    </v-snackbar>
  </div>
</template>

<script>

import MainMap from '@comp/Maps/MainMap.vue'
import { bus } from '@/bus.js' //引入bus.js定义的空的Vue实例
import MapboxVectorLayer from 'ol/layer/MapboxVector';
import { Vector,Tile } from 'ol/layer';
import { Polygon, LineString, MultiPolygon,MultiLineString,Point } from 'ol/geom'
import Feature from 'ol/Feature';
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import SearchBar from '@comp/Maps/utils/SearchBar.vue'
import SearchRangeSelector from "@comp/Maps/SearchVector/SearchRangeSelector.vue";
import L from 'leaflet'
import { LMap,LMarker,LTileLayer,LGeoJson,LWMSTileLayer} from 'vue2-leaflet'
import 'leaflet-mouse-position'
import myVector from "@views/myVector.vue";


export default {
  name: "vectoryLibrary",
  provide(){
    return{
      Home:this,// 允许一个祖先组件向其所有子孙后代注入一个依赖，不论组件层次有多深，并在起上下游关系成立的时间里始终生效。
      Search:this// 允许一个祖先组件向其所有子孙后代注入一个依赖，不论组件层次有多深，并在起上下游关系成立的时间里始终生效。
    }
  },
  components: {
    // SearchRangeSelector,
    // CascaderSelect,
    // FlowMonit,
    myVector,
    SearchBar,
    MainMap,
    // LMap,
    // LTileLayer,
    // LGeoJson,
  },
  data() {
    return {
      //提示相关参数
      snackbar:false,
      snackbarColor:"",
      snackbarInfo:"",
      timeout: 3000,

      //其他字段
      rootUrl:"https://www.jl1mall.com",
      // rootUrl:"http://localhost:8080",
      toTopShow: false,

      // 流量记录变量
      isShadow:0,
      canChangeKey:false,
      second: 5,
      timer:"",
      screenHeight:1920,
      showKey:0,
      oldKey:0,
      showCount:0,
      freebackShow:true,
      repositoryId:"",
      mapdialog:false,
      // tk:"",
      tkList:[],
      timeList:[],
      // mkList:[],
      calendarShow:false,
      calendarHover:false,
      leftHover:false,
      rightHover:false,
      year:2023,
      //这个月份显示01-12
      month:1,
      //这个月份显示从0-11
      month1:0,
      day:1,
      dayList:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31],
      monthList:[1,2,3,4,5,6,7,8,9,10,11,12],
      list:[],
      sevenList:[],
      canLeft:true,
      canRight:true,
      dateCanShow:[],
      yearSelect:2023,
      monthSelect:0,
      daySelect:1,
      totalNum:0,
      mkNumList:[],
      canUseCount:100000,
      canUseCountToday:40000,
      totalNumToday:0,
      repositoryIdList:[],
      repositoryListChange:false,
      newGuide:0,
      //地图
      showBak:true,
      tk:"",
      mkList:[],
      tileBaseUrl:'https://api.jl1mall.com',
      // tileBaseUrl:'https://mt.jl1mall.com',
      lyrdata: [],
      mapCtrlTools4Use: [2],
      mapParams: {
        projection:'EPSG:3857', //注意：必须加上此投影才能显示地图，目前有效的是4326和3857，而4490暂未生效
        center:[108.29883, 35.72902], //地图初始化时的中心坐标【基于4326坐标系】
        // center:[142.85524, 43.61710], //地图初始化时的中心坐标【基于4326坐标系】
        // mExtent:[120.45536,35.55856,139.36943,44.78707], //左下点-右上点
        minZoom:1, //可以缩小的最小级别；若此处未定义，地图接收到undefined则表示不受限制
        maxZoom:18, //可以放大的最大级别；若此处未定义，地图接收到undefined则表示不受限制
        zoom:4, //地图初始化时显示级别；注意：若此处未定义，地图初始化显示不出来
      },
      showMyLayersAndVectorPanel: true,

      /* 分页参数 */
      ipagination:{
        current: 1,
        pageSize: 1000,
        pageSizeOptions: ['10', '20', '50'],
        showTotal: (total, range) => {
          return range[0] + "-" + range[1] + " 共" + total + "条"
        },
        total: 0,
      },


      layersAndVectorsTabs: ['active', ''],
      loadGisMapRunOver: false,//用于判断mainmap是否加载完成

      overlay: false,

    };
  },
  methods: {
    disabledDate(current) {
      console.log("时间日期选择器")
      console.log(current)
      // Can not select days before today and today
      return current && current < moment().subtract(1, 'day').endOf('day');
    },
    getNowTime(){
      let dateTime = new Date();
      let year = dateTime.getFullYear();
      let month = dateTime.getMonth() + 1;
      let ri = dateTime.getDate();
      let day;
      switch (dateTime.getDay()) {
        case 0:
          day = "日";
          break;
        case 1:
          day = "一";
          break;
        case 2:
          day = "二";
          break;
        case 3:
          day = "三";
          break;
        case 4:
          day = "四";
          break;
        case 5:
          day = "五";
          break;
        case 6:
          day = "六";
          break;
        default:
          break;
      }
      let hours = dateTime.getHours();
      if(hours< 10){ hours="0" +hours }
      let minutes=dateTime.getMinutes();
      if(minutes< 10){ minutes="0" +minutes }
      let seconds=dateTime.getSeconds();
      if(seconds< 10){ seconds="0" +seconds }
      return year + "年" + month + "月" + ri + "日 星期"+ day + " " + hours + ":" +minutes + ":"+seconds;
    },
    //获取我的套件库
    queryRepositoryTkList: function () {
      this.axios.post("/tilesapi/tiles/repository/queryUserRepositoryList", null, {
        headers: {
          Authorization: 'Bearer ' + this.getKey(),
        }
      }).then((response) => {
        let tempArray=response.data.data;
        this.tkList_create=tempArray;
      })
    },
    //选择tk
    tkChange:function (value) {
      console.log(value)
      for (let i in this.tkList_create){
        if(this.tkList_create[i].id==value){
          this.mkList_create=this.tkList_create[i].mkList;
          break;
        }
      }
      console.log(this.mkList_create)
    },
    //带权限判断的跳转
    jumpWithPermission(type,path,fromUrl){
      //path:需要跳转到的路由；fromUrl：如果权限不满足，满足后回跳的路由
      //注意：fromUrl必须为包含本项目router中base的相对地址，如商城个人中心为：/store/UserCenter
      let loginUserId=localStorage.getItem('userId');//是否已登录
      let authentication=localStorage.getItem('authentication');//0:已实名；1：未实名
      if(type=='可游客'){
        if(fromUrl){
          window.open(this.rootUrl+path+"?fromUrl="+this.rootUrl+fromUrl,"_self")
        }
        else {
          window.open(this.rootUrl+path,"_self")
        }
      }else if(type=='仅登录'){
        //已登录
        if(loginUserId){
          if(fromUrl){
            window.open(this.rootUrl+path+"?fromUrl="+this.rootUrl+fromUrl,"_self")
          }
          else {
            window.open(this.rootUrl+path,"_self")
          }
        }
        //未登录
        else {
          if(fromUrl){
            window.open(this.rootUrl+'/Login'+"?fromUrl="+this.rootUrl+fromUrl,"_self")
          }
          else {
            window.open(this.rootUrl+'/Login',"_self")
          }
        }
      } else if (type == '仅实名') {
        //已登录
        if(loginUserId){
          //已实名
          if(authentication=='0'){
            if(fromUrl){
              window.open(this.rootUrl+path+"?fromUrl="+this.rootUrl+fromUrl,"_self")
            }
            else {
              window.open(this.rootUrl+path,"_self")
            }
          }else if(type=='仅登录'){
            //已登录
            if(loginUserId){
              if(fromUrl){
                window.open(this.rootUrl+path+"?fromUrl="+this.rootUrl+fromUrl,"_self")
              }
              else {
                window.open(this.rootUrl+path,"_self")
              }
            }
            //未登录
            else {
              if(fromUrl){
                window.open(this.rootUrl+'/Login'+"?fromUrl="+this.rootUrl+fromUrl,"_self")
              }
              else {
                window.open(this.rootUrl+'/Login',"_self")
              }
            }
          }else if(type=='仅实名'){
            //已登录
            if(loginUserId){
              //已实名
              if(authentication=='0'){
                if(fromUrl){
                  window.open(this.rootUrl+path+"?fromUrl="+this.rootUrl+fromUrl,"_self")
                }
                else {
                  window.open(this.rootUrl+path,"_self")
                }
              }
              //未实名
              else {
                window.open(this.rootUrl+'/Authentication',"_self")
              }

            }
            //未登录
            else {
              if(fromUrl){
                window.open(this.rootUrl+'/Login'+"?fromUrl="+this.rootUrl+fromUrl,"_self")
              }
              else {
                window.open(this.rootUrl+'/Login',"_self")
              }
            }
          }
          //未实名
          else {
            window.open(this.rootUrl+'/Authentication',"_self")
          }

        }
        //未登录
        else {
          if(fromUrl){
            window.open(this.rootUrl+'/Login'+"?fromUrl="+this.rootUrl+fromUrl,"_self")
          }
          else {
            window.open(this.rootUrl+'/Login',"_self")
          }
        }
      }
    },
    getKey() {
      return localStorage.getItem("token");
    },
    getLoginInfo() {
      console.log("getLoginInfo")
      console.log(this.getKey())
      let that = this;
      this.axios
          .get("/loginapi/getLoginInfo", {
            headers: {
              'Cache-Control': 'no-cache',
              Authorization: "Bearer " + this.getKey(),
            },
          })
          .then((res) => {
            if (res.data.success) {
              console.log("主页顶bar，getLoginInfo信息");
              this.print(res.data);
              this.$store.state.user.userId = res.data.data.account;
              this.$store.state.user.name = res.data.data.name;
              this.$store.state.user.vipLevel = res.data.data.vipLevel;
              this.setCookie("userId", res.data.data.account);
              this.setCookie(
                  "userInfo",
                  JSON.stringify({
                    phone: res.data.data.phone,
                    location: res.data.data.location,
                  })
              );
              this.$store.state.user.logined = true;
              let authentication = res.data.data.authentication
              this.$store.state.user.authentication =authentication; //是否实名认证，0是，1否
              this.setLocalStorageItem("authentication",authentication); //是否实名认证，0是，1否;为方便其他系统用
              this.setLocalStorageItem('token',res.data.data.key); //getuserInfo也需要赋值token，为把三部token替换为本部门token
              this.authenticationStatus=res.data.data.authentication
              this.vipLevel = res.data.data.vipLevel;
              this.vipType = res.data.data.vipType;
              this.vipActivityStatus = res.data.data.vipActivityStatus;
              this.avatar = res.data.data.avatar;
              if (res.data.data.endTime) {
                this.vip_endTime = res.data.data.endTime.split(" ")[0];
              }
            } else {
              this.$store.state.user.logined = false;
              // if (that.getCookie("userId")) {
              setTimeout(() => {
                this.$store.state.user.userId = "";
                // this.setCookie('userId', "");
                localStorage.setItem("userId", "");
                // this.$router.push("/Login");
                this.jumpWithPermission('仅实名','/rskit/viewMapSource','/rskit/viewMapSource')
              }, 2000);
              // }
            }
          });
    },
    setLocalStorageItem(key, value) {
      localStorage.setItem(key, value);
    },
    getIfTimeout(){
      let that=this;
      that.axios
          .get("/loginapi/getLoginInfo", {
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          })
          .then((res) => {
            this.print(res)
            if (res.data.success) {
              this.$store.state.user.userId = res.data.data.account;
              this.$store.state.user.name = res.data.data.name;
              this.$store.state.user.vipLevel = res.data.data.vipLevel;
              this.setCookie("userId", res.data.data.account);
              this.setCookie(
                  "userInfo",
                  JSON.stringify({
                    phone: res.data.data.phone,
                    location: res.data.data.location,
                  })
              );
              this.$store.state.user.logined = true;
              this.avatar = res.data.data.avatar;
              this.teacherStatus=res.data.data.teacherStatus;
              this.messageStatus=res.data.data.messageStatus;
              this.graduationStatus=res.data.data.graduationStatus;
              this.excellent=res.data.data.excellent;
            } else {
              this.$store.state.user.logined = false;
              if (that.getCookie("userId")) {
                setTimeout(() => {
                  this.$store.state.user.userId = "";
                  localStorage.setItem("userId", "");
                  this.$router.push("/Login");
                }, 2000);
              }
            }
          });
    },
    orderList(){
      this.axios.post("/tilesapi/tiles/register/queryTileOrder",null, {
        headers: {
          Authorization: "Bearer " + this.getKey(),
        },
      }).then((res) => {
        let data = res.data.data
        if (res.data.code==200) {
          for (let i = 0; i < data.length; i++) {
            const rep = data[i];
            if (rep.type=='1'&&rep.status=='已付款'&&rep.expireStatus!=2) {
                this.repositoryId = rep.repositoryId  
                break
            }
            if(rep.type=='4'&&rep.postStatus=='已交付'&&rep.expireStatus!=2){
                this.repositoryId = rep.repCountyList[0].repositoryId
                break
            }
            if (rep.type=='0') {
                this.repositoryId = rep.repositoryId  
                break
            }
          }
          this.getTk()
        }
      })
    },
    // getTk() {   //获取套件list
    //   this.axios.get("/tilesapi/tiles/repository/queryViewMapRepositoryMkDir",{
    //     headers: {
    //       Authorization: "Bearer " + this.getKey(),
    //     },
    //   }).then((res) => {
    //     let result = res.data.data
    //     this.mkList=[]
    //     if (res.data.code==200) {
    //       let tempTK = ''
    //       result.forEach(data => {
    //         // 判断全国一张图
    //         if(data.name.includes('2024年度全国高质量一张图')){
    //             data.mkList.forEach(mapItem => {
    //               mapItem.choose = true
    //               tempTK = mapItem.tkIv
    //               this.mkList.push(mapItem)
    //             });
    //         }
    //       });
    //       // 添加所有图层
    //       this.lyrdata = []
    //       this.mkList.forEach(v => {
    //         let temp = {
    //             lyrType:"Tile",
    //             srcType:"XYZ",
    //             mUrl:`${this.tileBaseUrl}/getTile/{z}/{x}/{-y}?mk=${v.mkIv}&tk=${v.tkIv}&vf=0`,
    //             mTitle:v.name,
    //             mName:v.name,
    //             mExtent:v.extent?v.extent.split(','):[],
    //             mVisible:v.choose
    //         }
    //         this.lyrdata.push(temp)
    //       })
    //       this.lyrdata.push({
    //           lyrType:"lVector",
    //           srcType:"Vector",
    //           mUrl:'',
    //           mTitle:"边框",
    //           mName:"边框",
    //           mVisible:true
    //       })
    //       this.tk = tempTK
    //       if (this.loadGisMapRunOver) {
    //         this.$refs.mainmap.curTk = this.tk
    //       }
    //     }
    //   })
    // },
    getTk() {
      this.axios.get("/tileflowapi/imagery/getUserTk", {
        params: { callScenario: "jl1" },
        headers: {
          Authorization: "Bearer " + this.getKey(),
        },
      }).then(res => {
        if (res.data.code==200) {
          this.tk = res.data.data.tk
          this.sk = res.data.data.sk

          this.mkList=[]
          if (res.data.code==200) {
            
            this.lyrdata = []
            
            let baseLayer = {
                lyrType:"Tile",
                srcType:"XYZ",
                mUrl:`${this.tileBaseUrl}/getTile/{z}/{x}/{-y}?mk=3ddec00f5f435270285ffc7ad1a60ce5&tk=${this.tk}&vf=0`,
                mTitle:'2024年全国一张图（底图）',
                mName:'2024年全国一张图（底图）',
                mExtent:[],
                mVisible:true,
                sk:this.sk
            }
            this.lyrdata.push(baseLayer)
            this.mkList.push(baseLayer)

            this.lyrdata.push({
                lyrType:"lVector",
                srcType:"Vector",
                mUrl:'',
                mTitle:"边框",
                mName:"边框",
                mVisible:true
            })
            
            if (this.loadGisMapRunOver) {
              this.$refs.mainmap.curTk = this.tk
            }
          }
        }
      });
    },
  },
  created() {
    //如果从商城端跳入，同步token状态
    let token=this.$route.query.tk;
    if(token){
      this.setLocalStorageItem('token',token);
    }

    this.getLoginInfo();
    //定时判断用户登录状态，每分钟一次，如果是登录超时则返回登录页
    this.$nextTick(() => {
      setInterval(this.getIfTimeout, 600000);
    });
  },
  mounted() {
    this.queryRepositoryTkList();
    // this.repositoryId= this.$store.state.repositoryId
    bus.$off('loadGisMapRunOver')
    bus.$on('loadGisMapRunOver', () => {
      this.showBak = false
      this.$refs.mainmap.curTk = this.tk
      this.loadGisMapRunOver=true
    })
    // this.orderList()
    this.getTk();
  },
  computed: {
  },
  watch:{

  },
}
</script>

<style lang="scss" scoped>

.shareListCtn {
  width: 620px;
  height: auto;
  min-height: 60px;
  max-height: 420px;
  overflow-y: auto;
  font-size: 18px;
  padding-left: 10px;
  word-break: break-all;
  color:#ffffff;
}

.shareListCtn::-webkit-scrollbar {
  width: 4px;
}

.shareListCtn::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}

.shareListCtn::-webkit-scrollbar-track {
}
::v-deep .ant-calendar-range-picker-input{
  font-size: 14px;
}
::v-deep .ant-select-selection__placeholder{
  margin-top: -7px;
}
::v-deep .ant-select-selection-selected-value{
  margin-top: 5px;
}
::v-deep .ant-select-selection {
  display: block;
  box-sizing: border-box;
  background: #2a2a2a;
  color: #b9b9b9;
  border: 1px solid #b9b9b9;
  border-top-width: 1.02px;
  border-radius: 4px;
  outline: none;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  height: 40px;
}
::v-deep .ant-modal-content {
  position: relative;
  background-color: #2A2A2A;
  background-clip: padding-box;
  border: 0;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  pointer-events: auto;
}
.overviewVectorDiv{
  width: 660px;
  height: 570px;
  // border:solid 1px #FF0000;
}
.createVectorButton{
  margin-left: 10px;
  float:left;
  width: 98px;
  height: 50px;
  border-radius: 8px;
  background: #1E81EB;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  text-align: center;
  line-height: 50px;
  cursor:pointer;
}
.createVectorButton_grey{
  margin-left: 10px;
  float:left;
  width: 98px;
  height: 50px;
  border-radius: 8px;
  background: #F5F5F6;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #575757;
  text-align: center;
  line-height: 50px;
}
.createVectorTitle{
  width: 1280px;
  height:40px;
  line-height: 40px;
  margin-bottom: 20px;
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
}
.createVectorDiv{
  width: 1280px;
  height: 600px;
  // border:solid 1px #9b2121;
}
.tableCtn{
  width: 100%;
  height:500px;
  padding-right: 20px;
  margin-top: 35px;
}
.searchAddCtn{
  width: 100%;
  padding-left: 180px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  margin-top: -10px;
}
::v-deep .ant-input {
  color: #ffffff;
}
.i-bottomCtn{
  display: flex;
  justify-content: center;
  width: 100%;
  height: 65px;
  border-top: solid 1px rgb(151, 151, 151);
  padding-top: 12px;
  .i-button{
    width: 102px;
    height: 40px;
    border-radius: 4px;
    border: 1px solid #979797;
    line-height: 40px;
    text-align: center;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    color: #FFFFFF;
    cursor:pointer;
  }
}
.createProjectLine {
  display: flex;
  justify-content: left;
  width: 100%;
  height: auto;
  min-height: 40px;
  margin-bottom: 20px;
  .item-name {
    position: relative;
    width: 90px;
    height: 40px;
    text-align: left;
    line-height: 40px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    color: #ffffff;
  }

  .item-input {
    width: 560px;
    min-height: 40px;
    height: auto;
    .edit-tj-ctn{
      width: 100%;
      min-height: 100px;
      height:auto;
      border-radius: 8px;
      border: solid 1px #d7d7d7;
      .item-ctn{
        width:100%;
        height:auto;
        padding:0px 10px 5px 10px;
        .tj-title{
          height:35px;
          line-height: 35px;
          font-size: 16px;
          width: auto;
        }
        .mk-ctn{
          width: 100%;
          min-height: 30px;
          line-height: 30px;
          border:dashed 1px #d0d0d0;
          padding: 3px;
          display: flex;
          justify-content: left;
          flex-wrap:wrap;
          .mk-item{
            height:24px;
            line-height: 24px;
            text-align: center;
            padding-left:3px;
            padding-right:3px;
            border-radius: 5px;
            border:solid 1px #75adee;
            font-size: 14px;
            min-width: 40px;
            width:auto;
            margin-right: 10px;
            margin-bottom:5px;
            margin-top:5px;
          }
        }
      }
    }
    .vectorCtn{
      width: 100%;
      height: 150px;
      color: #b9b9b9;
      .vectorListCtn{
        width: 100%;
        height: 110px;
        overflow-y: scroll;
        .itemCtn {
          height: 30px;
          line-height: 30px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #000000;
        }
      }
    }
  }
}
.createImgSeparateDialog{
  width: 715px;
  min-height: 514px;
  background: #2A2A2A;
  .i-titleCtn{
    position: relative;
    width: 100%;
    height: 50px;
    line-height: 50px;
    text-align: center;
    border-bottom: 1px solid #979797;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }
  .i-middleCtn{
    padding-top: 15px;
    padding-left: 35px;
    width: 100%;
    height: 450px;
  }
}
.shadow-imgSeparate {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
}
.createImgSeparateCtn{
  width: 159px;
  height: 41px;
  background: rgba(255,255,255,0.1);
  border-radius: 8px;
  margin-right: auto;
  margin-left: auto;
  margin-top: 20px;
  line-height: 41px;
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #FFFFFF;
  cursor:pointer;
}
.mapdiv{
  position: absolute;
  // width: calc(100% - 10px);
  // height: calc(100% - 10px);
  // left: 5px;
  // top: 5px;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.bak{
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: url('~@assets/Laboratory/背景.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
// ::v-deep .searchBar,
// ::v-deep .dfmAllDiv,
// ::v-deep .searchList{
//   left: 500px;
// }
// ::v-deep .dfmBtnDiv{
//   left: 710px;
// }

.laboratoryLogo{
  position: relative;
  .mark{
    position: absolute;
    width: 100px;
    height: 100vh;
    left: 0;
    top: 0;
    // background: linear-gradient(270deg, rgba(0,0,0,0) 20%, rgba(0,0,0,0) 77%, rgba(0,0,0,0.25) 88%, #000000 100%);
    background: linear-gradient(270deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.25) 40%, rgba(0, 0, 0, 0.5) 60%, #000000 100%);
  }
  .recordBtn{
    position: absolute;
    right: 30px;
    top: 90px;
    background: url('~@assets/Laboratory/流量查看_默认.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 54px;
    height: 54px;
    cursor: pointer;
  }
  .recordBtn:hover{
    background: url('~@assets/Laboratory/流量查看_hover.png');
  }
  .logoPanel{
    position: absolute;
    width: 440px;
    height: 54px;
    background: #2A2A2A;
    border-radius: 8px;
    top: 15px;
    left: 15px;
    .panelDoms{
      display: flex;
      align-items: center;
      height: 100%;
      .hoverNavi{
        cursor: pointer;
        background: url('~@assets/Laboratory/导航按钮_黑底.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        width: 44px;
        height: 44px;
        margin-left: 17px;
      }
      .hoverNavi:hover{
        background: url('~@assets/Laboratory/导航按钮_黑底_hover.png');
      }
      .hoverLogoContent{
        position: fixed;
        top: 60px;
        left: 20px;
        width: 0px;
        height: 0px;
        overflow: hidden;
        z-index: 1000;
      }
      .hoverWhite{
        position: fixed;
        top: 76px;
        left: 20px;
        width: 0px;
        height: 0px;
        background: #000;
        box-shadow: 2px 2px 10px 2px rgba(255,255,255,0.2);
        border-radius: 16px;
        transition: 0.3s;
        overflow: hidden;
        z-index: 1000;
      }
      .hoverMainImg{
        position: absolute;
        top: 20px;
        left: 44px;
        width: 175px;
        height: 40px;
      }
      .hoverJiantou{
        position: absolute;
        width: 18px;
        height: 16px;
        top: 35px;
        left: 433px;
      }
      .hoverLine{
        position: absolute;
        top: 80px;
        left: 28px;
        width: 444px;
        height: 1px;
        border-top: 1px solid #CCCCCC;
      }
      .hoverLogo{
        position: absolute;
        top: 100px;
        left: 28px;
        width: 220px;
        height: 60px;
        background: #000;
        border-radius: 6px;
      }
      .hoverLogo:hover{
        background: rgba(0,0,0,0.7);
      }
      .hoverImg{
        position: absolute;
        top: 19px;
        left: 24px;
        width: 20px;
        height: 20px;
      }
      .hoverLogoText1{
        position: absolute;
        top: 17px;
        left: 66px;
        width: 85px;
        height: 24px;
        font-size: 20px;
        font-family: Tensentype-ZhiHeiJ-W4, Tensentype-ZhiHeiJ;
        font-weight: normal;
        color: #fff;
        line-height: 24px;
      }
      .hoverLogoText2{
        position: absolute;
        top: 35px;
        left: 66px;
        width: 133px;
        height: 17px;
        font-size: 12px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 300;
        color: rgba(255,255,255,0.7);
        line-height: 17px;
        opacity: 0;
      }
      .dashedLine{
        width: 1px;
        height: 26px;
        border: 1px solid rgba(255,255,255,0.75);
        margin-left: 15px;
      }
      .logo{
        background: url('~@assets/Laboratory/实验室logo_white.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        width: 132px;
        height: 42px;
        margin-left: 25px;
        margin-top: 5px;
      }
      .introductionBtn{
        cursor: pointer;
        position: absolute;
        // top: 12px;
        right: 14px;
        width: 54px;
        height: 30px;
        background: rgba(255,255,255,0.15);
        border-radius: 6px;
        display: flex;
        justify-content: center;
        align-items: center;

        font-size: 14px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 300;
        color: #EAEAEA;
        line-height: 20px;
      }
    }

    .moreTools{
      position: absolute;
      width: calc(100vw - 580px);
      height: 54px;
      background: #2A2A2A;
      border-radius: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      top: 0;
      left: 445px;
      z-index: 1000;

      font-size: 14px;
      font-family: PingFangSC-Light, PingFang SC;
      font-weight: 300;
      color: #CCCCCC;
      line-height: 20px;

      .closeImg{
        position: absolute;
        right: 11px;
        cursor: pointer;
      }
    }
    .closePanel{
      position: absolute;
      right: -25px;
      top: 0px;
      cursor: pointer;
      background: url('~@assets/Laboratory/展开按钮_默认.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      width: 20px;
      height: 54px;
    }
    .closePanel:hover{
      background: url('~@assets/Laboratory/展开按钮_hover.png');
    }
  }
  .layersAndVectorsPanel{
    position: absolute;
    width: 405px;
    height: 100vh;
    background: #2A2A2A;
    top: 0px;
    left: 0px;
    z-index: 1;
    /* 勾选框样式，有点乱 */
    ::v-deep .ant-checkbox-checked::after{
      background: url('~@assets/Laboratory/单选框选中.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      border: unset;
      transform: unset;
      visibility: unset;
      box-shadow: 1px 1px 2px 0px rgba(184,184,184,0.5), inset 0px 0px 2px 0px rgba(0,0,0,0.5);
    }
    ::v-deep .ant-checkbox-disabled{
      background: url('~@assets/Laboratory/单选框选中.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    ::v-deep .ant-checkbox-checked .ant-checkbox-inner::after{
      opacity: unset;
      transform: unset;
      border: unset !important;
    }
    ::v-deep .ant-checkbox-inner::after{
      border: unset;
    }
    ::v-deep .ant-checkbox-checked .ant-checkbox-inner{
      background-color: unset;
      border: unset;
    }
    ::v-deep .ant-checkbox-inner{
      background-color: unset;
      background: url('~@assets/Laboratory/单选框默认.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      border: unset;
      transform: unset;
      visibility: unset;
      box-shadow: 1px 1px 2px 0px rgba(184,184,184,0.5), inset 0px 0px 2px 0px rgba(0,0,0,0.5);
    }


    ::v-deep .ant-select-selection{
      background: rgba(0,0,0,0.5);
      color: white;
    }
    ::v-deep .ant-select-arrow{
      color: white;
    }

    .tabs{
      width: 100%;
      height: 56px;
      line-height: 56px;
      display: flex;
      border-bottom: 1px solid rgba(255,255,255,0.25);
      align-items: center;
      justify-content: center;
      cursor: pointer;
      font-size: 14px;
      font-family: PingFangSC-Light, PingFang SC;
      font-weight: 300;
      color: #FFFFFF;
      line-height: 20px;
      background: rgba(0,102,204,0.15);


    }

    .ps {
      // height: 885px;
      // height: 1782px;
      height: calc(100vh - 156px);
      position: unset;
      .ps__rail-y,
      .ps__rail-y.ps__thumb-y{
        right: 18px !important;
      }
    }
    .tabPanels{
      color: white;
      height: calc(100% - 56px);
      // 滚动条样式

      .layersPanel{
        position: relative;
        max-height: 100%;
        overflow-y: auto;
        // overflow-y: hidden;
        overflow-x: hidden;
        // >div:nth-child(1){
        .ant-checkbox-group{
          margin-left: 20px;
          // width: 100%;
          // width: calc(100% - 30px);
          width: calc(100% - 20px);
        }
      }
      // .layersPanel:hover{
      //   overflow-y: overlay;
      // }
      .layersLi{
        position: relative;
        display: flex;
        align-items: center;
        height: 54px;
        color: #FFFFFF;
        font-weight: 400;
        .thumbImg{
          width: 42px;
          height: 42px;
          border: 1px solid rgba(255,255,255,0.2);
          margin-left: 15px;
          margin-right: 15px;
          img{
            width: 42px;
            height: 42px;
            padding: 5px;
          }
        }
        .mkInfo{
          >div:nth-child(2){
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #979797;
            line-height: 17px;
          }
        }
        .juanlianBtn{
          cursor: pointer;
          position: absolute;
          right: 10px;
          background: url('~@assets/Laboratory/卷帘对比_默认.png');
          background-repeat: no-repeat;
          background-size: 100% 100%;
          width: 30px;
          height: 30px;
        }
        .juanlianBtn:hover{
          background: url('~@assets/Laboratory/卷帘对比_hover.png');
        }
      }
      .vectorLi{
        .thumbImg{
          img{
            padding: 10px;
          }
        }
      }
    }
    .closePanel{
      position: absolute;
      top: calc(50% - 74px);
      right: -25px;
      cursor: pointer;
      background: url('~@assets/Laboratory/收起按钮_默认.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      width: 20px;
      height: 54px;
    }
    .closePanel:hover{
      background: url('~@assets/Laboratory/收起按钮_hover.png');
    }
  }

  .closePanelImg{
    cursor: pointer;
    position: absolute;
    left: 15px;
    top: calc(50vh - 54px);
    width: 20px;
    height: 54px;
    background: url('~@assets/Laboratory/展开按钮_默认.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .closePanelImg:hover{
    background: url('~@assets/Laboratory/展开按钮_hover.png');
  }
}

.shadow {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 10000;
  .dialog {
    position: absolute;
    width: 1080px;
    height: 680px;
    border-radius: 16px;
    left: calc(50% - 540px);
    top: calc(50% - 340px);
    z-index: 10001;
    background: #2A2A2A;

    // overflow-y: auto;
    // overflow-x: hidden;
    .dialogImg {
      position: absolute;
      top: 0;
      right: -50px;
      cursor: pointer;
    }
    .introductionImg{
      width: 100%;
      // max-height: 100%;
      // overflow-y: auto;
    }
  }
}
.dialog .introduction{
  overflow-y: auto;
  overflow-x: hidden;
  // overflow: hidden;
  position: relative;
  width: 100%;
  height: 100%;
  padding: 10px;
  // 滚动条样式
  .ps {
    height: 660px;
  }
}
// .dialog .introduction:hover{
//   overflow-y: overlay;
// }

.shadow_tools_tip {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 10000;
  .dialog {
    display: flex;
    flex-direction: column;
    // justify-content: center;
    align-items: center;
    position: absolute;
    width: 768px;
    height: 460px;
    border-radius: 16px;
    left: calc(50% - 384px);
    top: calc(50% - 230px);
    z-index: 10001;
    background: #2A2A2A;
    .dialogImg {
      position: absolute;
      top: 0;
      right: -50px;
      cursor: pointer;
    }
    >div:nth-child(2){
      width: 36px;
      height: 25px;
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #FFFFFF;
      line-height: 25px;
      margin: 50px 0;
    }
    >div:nth-child(3){
      width: 600px;
      height: 120px;
      font-size: 16px;
      font-family: PingFangSC-Light, PingFang SC;
      font-weight: 300;
      color: #FFFFFF;
      line-height: 30px;
    }
    >div:nth-child(4){
      margin: 100px 0;
    }
  }
}
.shadow_tip {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 10000;
  .dialog {
    display: flex;
    flex-direction: column;
    // justify-content: center;
    align-items: center;
    position: absolute;
    width: 768px;
    height: 460px;
    border-radius: 16px;
    left: calc(50% - 384px);
    top: calc(50% - 230px);
    z-index: 10001;
    background: #2A2A2A;

    >div:nth-child(1){
      width: 36px;
      height: 25px;
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #FFFFFF;
      line-height: 25px;
      margin: 50px 0;
    }
    >div:nth-child(2){
      width: 600px;
      height: 120px;
      font-size: 16px;
      font-family: PingFangSC-Light, PingFang SC;
      font-weight: 300;
      color: #FFFFFF;
      line-height: 30px;
    }
    >div:nth-child(3){
      margin: 100px 0;
    }
  }
}
.tabsNavi{
  position: absolute;
  width: calc(100vw - 405px);
  height: 56px;
  background: #2A2A2A;
  top: 0;
  left: 405px;
}
.tabsNavi-s{
  position: absolute;
  width: 100vw;
  height: 56px;
  background: #2A2A2A;
  top: 0;
  left: 0px;
}
.tabsNaviInput{
  position: absolute;
  top: 0;
  left: 25px;
  width: 262px;
  height: 42px;
  border-bottom: 1px solid #FFFFFF;
  opacity: 0.7;
}
.tabsNaviInput1{
  position: absolute;
  width: 250px;
  top: 15px;
  left:0px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 500;
  color: #fff;
  line-height: 20px;
  border:none;
  outline: none;
}
.tabsNaviSearch{
  position: absolute;
  top: 18px;
  right: 5px;
  cursor: pointer;
}
.tabsNaviChange{
  position: absolute;
  top: 17px;
  left: calc(50% - 175px);
  width:350px;
  height: 40px;
  font-size: 14px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #979797;
  line-height: 20px;
  cursor: pointer;
  text-align: right;
  padding-right: 20px;
}
.tabsNaviList{
  position: absolute;
  top:40px;
  right:-20px;
  width: auto;
  height:auto;
  box-shadow: 0px 0px 5px 0px rgba(255,255,255,0.2);
  border-radius: 8px;
}
.tabsNaviList1{
  background: #2A2A2A;
  width:auto;
  height: 60px;
  font-size: 14px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #979797;
  line-height: 20px;
  background: #2A2A2A;
  cursor: pointer;
  padding-top: 10px;
  padding-left: 40px;
  padding-right: 40px;
  text-align: left;
}
.tabsNaviList1:hover{
  background: grey;
  color: #3a3a3a;

}
.tabsNaviList11{
  background: #2A2A2A;
  width:auto;
  height: 60px;
  font-size: 14px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #979797;
  line-height: 20px;
  background: #2A2A2A;
  cursor: pointer;
  padding-top: 10px;
  padding-left: 40px;
  padding-right: 40px;
  text-align: left;
  border-radius: 8px 8px 0 0;
}
.tabsNaviList11:hover{
  background: grey;
  color: #3a3a3a;

}
.tabsNaviList12{
  background: #2A2A2A;
  width:auto;
  height: 60px;
  font-size: 14px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #979797;
  line-height: 20px;
  background: #2A2A2A;
  cursor: pointer;
  padding-top: 10px;
  padding-left: 40px;
  padding-right: 40px;
  text-align: left;
  border-radius: 0 0 8px 8px;
}
.tabsNaviList12:hover{
  background: grey;
  color: #3a3a3a;

}
.tabsNaviClose{
  position: absolute;
  top: 17px;
  right: 40px;
  width: 28px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #CCCCCC;
  line-height: 20px;
  cursor: pointer;
}
.tabPanelsSearch{
  position: relative;
  margin-top: 27px;
  margin-left: 19px;
  width: 400px;
  height: 44px;
  background: #3A3A3A;
  border-radius: 22px;
}
.tabPanelsBlock1{
  position: relative;
  margin-left: 4px;
  width: 431px;
  height: 52px;
  cursor: pointer;
}
.tabPanelsBlock1-s{
  position: relative;
  margin-left: 4px;
  width: 431px;
  height: 52px;
  background: rgba(0,102,204,0.1);
  cursor: pointer;
}
.tabPanelsBlock1:hover{
  background: rgba(0,102,204,0.1);
}
.tabBlock1Select{
  position: absolute;
  top: 19px;
  left: 13px;
}
.tabBlock1Text1{
  position: absolute;
  top: 5px;
  left: 96px;
  width:350px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #FFFFFF;
  line-height: 20px;
}
.tabBlock1Text2{
  position: absolute;
  top: 32px;
  left: 115px;
  width: 40px;
  height: 16px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #979797;
  line-height: 17px;
}
.tabBlock1Text3{
  position: absolute;
  top: 40px;
  left: 96px;
  width: 300px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #979797;
  line-height: 20px;
}
.tabBlock1Button1{
  position: absolute;
  top: 90px;
  left: 153px;
  width: 125px;
  height: 32px;
  background: #EAEAEA;
  border-radius: 8px;
  font-size: 14px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #3A3A3A;
  line-height:32px;
  text-align: center;
  cursor: pointer;
}
.newGuideShadow{
  position: fixed;
  left: 440px;
  top: 0;
  width: calc(100vw - 440px);
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 10000;
}
.newGuide1Text1{
  position: absolute;
  top: 54px;
  left: 131px;
  width: 250px;
  height: 30px;
  font-size: 24px;
  font-family: HanziPenSC-W5, HanziPenSC;
  font-weight: normal;
  color: #FFFFFF;
  line-height: 30px;
}
.newGuide4Text1{
  position: absolute;
  top: 0px;
  right: 70px;
  width: 250px;
  height: 30px;
  font-size: 24px;
  font-family: HanziPenSC-W5, HanziPenSC;
  font-weight: normal;
  color: #FFFFFF;
  line-height: 30px;
}
.newGuide1Block{
  position: absolute;
  top: 99px;
  left: 30px;
  width: 400px;
  height: 300px;
  border-radius: 8px;
  border: 2px solid #FFFFFF;
}
.newGuide4Block{
  position: absolute;
  top: 40px;
  right: 30px;
  width: 400px;
  height: 300px;
  border-radius: 8px;
  border: 2px solid #FFFFFF;
}
.newGuideBlock1{
  position: absolute;
  top: 6px;
  left: 6px;
  width: 386px;
  height: 286px;
  border-radius: 3px;
  border: 1px solid rgba(255, 255, 255, 0.5);
}
.newGuide1Text2{
  position: absolute;
  top: 19px;
  left: 28px;
  width: 330px;
  height: 185px;
  font-size: 21px;
  font-family: HanziPenSC-W5, HanziPenSC;
  font-weight: normal;
  color: #FFFFFF;
  line-height: 35px;
}
.newGuide1Button1{
  position: absolute;
  top: 233px;
  left: 83px;
  width: 100px;
  height: 30px;
  background: #FFFFFF;
  border-radius: 8px;
  font-size: 21px;
  font-family: HanziPenSC-W5, HanziPenSC;
  font-weight: normal;
  color: #000;
  line-height: 35px;
  text-align: center;
  cursor: pointer;
}
.newGuideShadow31{
  position: fixed;
  left: 0px;
  top: 0;
  width: 440px;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 10000;
}
.newGuideShadow32{
  position: fixed;
  left: 770px;
  top: 0px;
  width: calc(100vw - 770px);
  height: 85px;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 10000;
}
.newGuideShadow33{
  position: fixed;
  left: 440px;
  top:85px;
  width: calc(100vw - 440px);
  height: calc(100vh - 85px);
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 10000;
}
.newGuideShadow41{
  position: fixed;
  left: 0px;
  bottom:375px;
  width: 100vw;
  height: calc(100vh - 375px);
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 10000;
}
.newGuideShadow42{
  position: fixed;
  left: 0px;
  right: 150px;
  bottom:0px;
  width: calc(100vw - 150px);
  height: 375px;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 10000;
}
.newGuideShadow43{
  position: fixed;
  right: 0px;
  bottom:0px;
  width: 150px;
  height: 40px;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 10000;
}
.fenpingShadow{
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10000;
}
.shadowContent11{
  position: fixed;
  top: calc(50% - 160px);
  left: calc(50% - 400px);
  width: 800px;
  height: 320px;
  background: #FFFFFF;
  border-radius: 12px;
}
.shadowText11{
  position: absolute;
  top: 50px;
  left: calc(50% - 150px);
  width: 300px;
  height: 60px;
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #3A3A3A;
  line-height: 25px;
  line-height: 30px;
  text-align: center;
}
.shadowText22{
  position: absolute;
  top: 124px;
  left: 120px;
  width: 560px;
  height: 50px;
  font-size: 14px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #3A3A3A;
  line-height: 25px;
  text-align: center;
}
.shadowButton11{
  position: absolute;
  top:234px;
  left:261px;
  width: 169px;
  height: 40px;
  background: #0066CC;
  border-radius: 6px;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
}
.shadowButton22{
  position: absolute;
  top: 234px;
  left: calc(50% - 50px);
  width: 100px;
  height: 40px;
  background: #FFFFFF;
  border-radius: 6px;
  border: 1px solid #0066CC;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 500;
  color: #0066CC;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
}


</style>
<!-- 流量样式 -->
<style scoped>
.bar{
  position: relative;
  width: 100%;
  height: 76px;
  background-color: #fff;
}
.freeback{
  position: relative;
  width: 100%;
  height: 40px;
  background: #0066CC;
}
.freebackBlue{
  position: absolute;
  width: 1920px;
  height: 40px;
}
.freebackText{
  position: absolute;
  left:50%;
  transform:translate(-50%,0);
  width: 800px;
  height:40px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  line-height:40px;
  text-align: center;
  z-index: 1;
}
.freebackClose{
  position: absolute;
  width: 14px;
  height: 14px;
  right: 50px;
  top: 13px;
  cursor: pointer;
}
.navi{
  position: relative;
  width: 100%;
  height: 40px;
  background: #F5F5F6;
}
.naviContent{
  position: absolute;
  width: 1920px;
  height: 40px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #3A3A3A;
  line-height: 40px;
  padding-left: 120px;
}
.greyBasis{
  position: relative;
  width: 100%;
  height: auto;
  background-color: #fff;
  overflow: hidden;
}
.basisTitle{
  position: absolute;
  top: 43px;
  left: calc(50% - 201px);
  width: 402px;
  height: 42px;
  z-index: 1;
}
.basisText1{
  position: absolute;
  top: 53px;
  left: calc(50% - 400px);
  width:800px;
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #3A3A3A;
  line-height: 22px;
  text-align: center;
  z-index: 2;
}
.greyContent{
  margin-top: 50px;
  margin-left: calc(50% - 640px);
  width: 1280px;
  height:auto;
  background: #F7F7F7;
  border-radius: 16px;
  padding-bottom: 20px;
  margin-bottom: 50px;
  overflow: hidden;
}
.keyManage{
  position: relative;
  margin-left: calc(50% - 560px);
  width: 1120px;
  height: 48px;
  /* background-color: pink; */
  margin-top: 75px;
  margin-bottom: 50px;
}
.greyList{
  position: relative;
  margin-left: calc(50% - 560px);
  margin-bottom: 10px;
  width: 1120px;
  height: 54px;
  background: #FFFFFF;
  border-radius: 8px;
  overflow: hidden;
}
.greyListBlock{
  position: relative;
  margin-top: 17px;
  margin-left: 222px;
  margin-bottom: 17px;
  width: 600px;
  height: 20px;
}
.greyList-s{
  position: relative;
  margin-left: calc(50% - 560px);
  margin-bottom: 80px;
  width: 1120px;
  height: 54px;
  background: #FFFFFF;
  border-radius: 8px;
}
.greyListText1{
  position: absolute;
  right: 749px;
  top: 17px;
  width:400px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #3A3A3A;
  line-height: 20px;
  text-align: right;
}
.gretListLine{
  position: absolute;
  top: 14px;
  left: 400px;
  width: 2px;
  height: 26px;
  background-color:#979797 ;
  opacity: 0.5;
}
.greyListText{
  position: absolute;
  top: 17px;
  left: 430px;
  width: 483px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #777777;
  line-height: 20px;
}
.greyListText-s{
  position: relative;
  margin-top: 13px;
  margin-bottom: 20px;
  margin-left: 422px;
  width: 690px;
  height: 20px;
}
.greyListText-s1{
  position: relative;
  margin-bottom: 20px;
  margin-left: 422px;
  width: 690px;
  height: 20px;
}
.greyListText1-s{
  position: absolute;
  left: 8px;
  width: 280px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #B8B8B8;
  line-height: 20px;
}
.greyListLine{
  position: absolute;
  top: 10px;
  left: 0;
  width: 280px;
  height: 1px;
  background:  #B8B8B8;
}
.greyListText2-s{
  position: absolute;
  left: 330px;
  width: 150px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #777777;
  line-height: 20px;
}
.keyLine1{
  position: absolute;
  top: 24px;
  left: 0;
  width: 508px;
  height: 1px;
  border-bottom: 1px dashed #979797;
}
.keyLine2{
  position: absolute;
  top: 24px;
  right: 0;
  width: 508px;
  height: 1px;
  border-bottom: 1px dashed #979797;
}
.keyIcon1{
  position: absolute;
  top: 0;
  left: calc(50% - 40px);
  width: 80px;
  height: 48px;
}
.keyIcon2{
  position: absolute;
  top: 19px;
  right: 55px;
  cursor: pointer;
}
.keyIcon3{
  position: absolute;
  top: 19px;
  right: 100px;
  cursor: pointer;
}
.keyIcon_compare{
  position: absolute;
  top: 20px;
  right: 15px;
  cursor: pointer;
}
.keyIcon4{
  position: absolute;
  top: 13px;
  right: 23px;
  cursor: pointer;
}
.keyTitle{
  position: absolute;
  top: 13px;
  left: calc(50% - 60px);
  width: 120px;
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #3A3A3A;
  line-height: 22px;
  text-align: center;
}
.countTitle{
  margin-left: calc(50% - 400px);
  margin-top: 50px;
  margin-bottom: 25px;
  width: 800px;
  height: 20px;
  text-align: center;

  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #FFFFFF;
  line-height: 25px;
}
.countText1{
  margin-left: calc(50% - 400px);
  margin-bottom: 25px;
  width: 800px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #CCCCCC;
  line-height: 20px;
  text-align: center;
}
.countWhite{
  position: relative;
  /* margin-left: calc(50% - 500px); */
  /* margin-bottom: 80px; */
  width: 1000px;
  height: 520px;
  /* background: #FFFFFF; */
  border-radius: 8px;
  color: #FFFFFF;
  /* display: flex;
  justify-content: center;
  align-items: center; */
}
.greyImg{
  position: absolute;
  top: 30px;
  left: 67px;
  width: 41px;
  height: 41px;
  background: #5b5b5b1b;
  border-radius: 50%;
  cursor: pointer;
}
.countIcon1{
  position: absolute;
  top: 41px;
  left: 79px;
  cursor: pointer;
}
.countIcon3{
  position: absolute;
  width: 20px;
  height: 20px;
  top: 5px;
  right: 5px;
  cursor: pointer;
}
.countIcon2{
  position: absolute;
  top: 41px;
  left: 250px;
  cursor: pointer;
}
.countText2{
  position: absolute;
  top: 38px;
  left: 271px;
  width: 90px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 20px;
  text-align: center;
}
.countCalendar{
  position: absolute;
  width: 476px;
  height: 224px;
  top: 103px;
  left: 68px;
}
.countCircle{
  position: relative;
  float: left;
  margin-left: 10px;
  margin-bottom: 11px;
  width: 44px;
  height: 44px;
  cursor: pointer;
}
.countCirclespe1{
  position: relative;
  float: left;
  margin-left: 108px;
  margin-bottom: 11px;
  width: 44px;
  height: 44px;
  cursor: pointer;
}
.countCirclespe2{
  position: relative;
  float: left;
  margin-left: 0px;
  margin-bottom: 11px;
  width: 44px;
  height: 44px;
  cursor: pointer;
}
.countCircle1{
  position: absolute;
  top: 0;
  left: 0;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: transparent;
}
.countCircle2{
  position: absolute;
  top: 4px;
  left: 4px;
  width: 36px;
  height: 36px;
  background-color: rgb(42 42 42);
  border-radius: 50%;
  text-align: center;
  line-height: 36px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF ;
}
.calendarDialog{
  position: absolute;
  width: 400px;
  height: 150px;
  background: #FFFFFF;
  box-shadow: 1px 1px 5px 2px rgba(0,0,0,0.2);
  top: 75px;
  left: 79px;
  z-index: 1;
}
.calendarDialog{
  position: absolute;
  width: 400px;
  height: 150px;
  background: #FFFFFF;
  box-shadow: 1px 1px 5px 2px rgba(0,0,0,0.2);
  top: 75px;
  left: 79px;
  z-index: 1;
}
.calendarYear{
  position: absolute;
  width: 64px;
  height: 30px;
  background: #fff;
  top: 15px;
  left: 100px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  font-family: PingFangSC-Semibold, PingFang SC;
  color: #3A3A3A;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
}
.calendarYear-s{
  position: absolute;
  width: 64px;
  height: 30px;
  background: #fff;
  top: 15px;
  left: 100px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  font-family: PingFangSC-Semibold, PingFang SC;
  color: #49C2FF;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
}
.calendarYear:hover{
  background: #F7F7F7;
}
.calendarMonth{
  position: absolute;
  width: 330px;
  height: 64px;
  top: 65px;
  left: 43px;
}
.calendarMonth1{
  float: left;
  background: #fff;
  margin-right: 15px;
  margin-bottom: 12px;
  width: 40px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #3A3A3A;
  line-height: 20px;
  text-align: center;
  cursor: pointer;
}
.calendarMonth1-s{
  float: left;
  background: #fff;
  margin-right: 15px;
  margin-bottom: 12px;
  width: 40px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 600;
  color: #49C2FF;
  line-height: 20px;
  text-align: center;
  cursor: pointer;
}
.calendarMonth1:hover{
  background: #F7F7F7;

}
.totalStatistics{
  position: absolute;
  top: 342px;
  left: 79px;
  width: 480px;
  height: 42px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 22px;
}
.calendarTip{
  position: absolute;
  bottom: 60px;
  left: 79px;
  width: 480px;
  height:auto;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #777777;
  line-height: 22px;
}
.mkStatistics{
  top: 40px;
  left: 630px;
  position: absolute;
  height: 420px;
  width: 380px;
  overflow-y: auto;
  overflow-x: hidden;
}
.mkNum{
  position: relative;
  width: 500px;
  height: 20px;
  margin-bottom: 20px;
}
.mkNumName{
  position: absolute;
  left: 0;
  top: 0;
  width: 300px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  /* color: #3A3A3A; */
  color: #FFFFFF;
  line-height: 20px;
}
.mkNumCount{
  position: absolute;
  left: 300px;
  width: 100px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  /* color: #777777; */
  color: #979797;
  line-height: 20px;
}
.greyButton{
  margin-left: calc(50% - 75px);
  width: 150px;
  height: 40px;
  background: #1E81EB;
  border-radius: 8px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
  margin-bottom: 125px;
}
.shadow {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
}
.shadowContent1{
  position: fixed;
  top: calc(50% - 200px);
  left: calc(50% - 400px);
  width: 800px;
  height: 400px;
  background: #FFFFFF;
  border-radius: 12px;
}
.shadowClose{
  position: absolute;
  width: 40px;
  height: 40px;
  top: 0px;
  right: -55px;
  cursor: pointer;
}
.shadowtext1{
  position: absolute;
  top: 50px;
  left: calc(50% - 60px);
  width: 120px;
  height: 25px;
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #3A3A3A;
  line-height: 25px;
  text-align: center;
}
.shadowText2{
  position: absolute;
  top: 108px;
  left: 74px;
  width: 660px;
  height: 150px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 30px;
}
.shadowButton{
  position: absolute;
  top: 307px;
  left: calc(50% - 75px);
  width: 150px;
  height: 40px;
  background: #CCCCCC;
  border-radius: 6px;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 40px;
  text-align: center;
}
.shadowButton1{
  position: absolute;
  top: 307px;
  left: calc(50% - 75px);
  width: 150px;
  height: 40px;
  background: #0066CC;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 40px;
  text-align: center;
}

::v-deep .mapDialog{
  overflow-y: unset;
  z-index: 1001;
}
::v-deep .theme--light.v-card{
  background: rgba(238,238,238);
}
</style>

<style lang="scss" scoped>

// 滚动条宽度
div::-webkit-scrollbar{
  width: 10px;
}
// 滚动条轨道
div::-webkit-scrollbar-track{
  background: rgb(239, 239, 239,0);
  border-radius: 2px;
}
// 小滑块
div::-webkit-scrollbar-thumb{
  background: rgba(76, 76, 76, 0.8);
  border-radius: 10px;
}
div::-webkit-scrollbar-thumb:hover{
  background: rgba(76, 76, 76, 1);
}

::v-deep .ps__thumb-y{
  cursor: pointer;
}
::v-deep .ps .ps__rail-x:hover,
::v-deep .ps .ps__rail-y:hover,
::v-deep .ps .ps__rail-x:focus,
::v-deep .ps .ps__rail-y:focus,
::v-deep .ps .ps__rail-x.ps--clicking,
::v-deep .ps .ps__rail-y.ps--clicking {
  background-color: unset;
  opacity: 0.9;
}
</style>

<style lang="scss" scoped>
.fast_btn {
  // width: 128px;
  margin: 0 auto;
  padding-left: 0px;
  .content_btn {
    width: 128px;
    height: 44px;
    margin: 0 auto;
    background: linear-gradient(180deg, #229bff 0%, #0071e3 100%);
    border-radius: 27px;
    border: 1px solid transparent;/*消除悬停时一像素错位调动的问题*/
    outline: none;
    color: #ffffff;
    text-align: center;

    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    line-height: 20px;
  }
  .content_btn_border {
    margin-left: 20px;
    width: 128px;
    height: 44px;
    border-radius: 27px;
    border: 1px solid #ffffff;
    text-align: center;
    color: #ffffff;
    background: rgba(0, 0, 0, 0);//去掉浅蓝色背景的干扰


    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    line-height: 20px;
  }
}
</style>


<!-- POI -->
<style lang="scss" scoped>
.dfmBtn{
  position: absolute;
  top: 18px;
  left: 210px;
  color: white;
}
::v-deep .dfmBtnDiv{
  cursor: pointer;
  position: absolute;
  // top: 25px;
  top: 13px;
  left: 235px;
  // border: #a4a4a4 1px solid;
  border-radius: 4px;
  width: 30px;
  height: 30px;
  background-color: rgba(42 42 42);
  display: flex;
  align-items: center;
  justify-content: center;
}
::v-deep .dfmAllDiv{
  position:absolute;
  display:flex;
  align-items:center;
  width:500px;
  z-index:999;
  // top:25px;
  top:13px;
  left: 25px;
}
::v-deep .sjzBtnDiv{
  cursor: pointer;
  margin-left: 10px;
  // border: #a4a4a4 1px solid;
  border-radius: 4px;
  width: 30px;
  height: 30px;
  background-color: rgba(42 42 42);
  display: flex;
  align-items: center;
  justify-content: center;
}
::v-deep .searchBar{
  position: absolute;
  width: 200px;
  // top: 25px;
  top: 13px;
  left: 25px;
  background: #2A2A2A;
}
.searchList{
  position: absolute;
  min-width: 424px;
  top: 65px;
  left: -10px;
  box-shadow: 0px 0px 5px 0px rgba(255,255,255,0.2);
  border-radius: 8px;
}
// ::v-deep .ant-list-items{
.searchListItem{
  background: #2A2A2A;
  div{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 38px;
    color:white;
    a{
      font-size:14px;
      color:white;
    }
    span{
      font-size:12px;
      margin-left:30px;
      color:white;
    }
  }
}
::v-deep .ant-spin-container{
  background: unset;
}
::v-deep .ant-list-item{
  border-bottom: unset !important;
}
::v-deep .anticon,
::v-deep .ant-input-suffix,
::v-deep .ant-input-suffix:hover{
  color:rgb(185, 185, 185);
}
::v-deep .ant-input-clear-icon:hover{
  color:rgb(255, 255, 255);
}
::v-deep .ant-input{
  background: rgba(42 42 42);
  color:rgb(185, 185, 185);
}
::v-deep .ant-input-clear-icon{
  color:rgb(185, 185, 185);
}
::v-deep ul{
  padding-left:unset;
}
.homeStyle{
  left: 524px;
}
.homeBtnStyle{
  left: 730px;
}
.homeBtnTenStyle{
  left: 1030px;
}
</style>